import {
  Box,
  Typography,
  Divider,
  TextField,
  Button,
  Collapse,
  Alert,
  CircularProgress,
  Radio,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  List,
} from '@mui/material';
import { HexColorPicker } from 'react-colorful';
import {
  DocumentTypeControllerState,
  DocumentTypeControllerAction,
} from '../../controller/document.type.controller';
import CloseButton from '../../../../components/closebutton/CloseButton';
import { FormFlowType } from '../../data/form-type';
import { DocumentTypeCategoryModel } from '../../model/doc-type-cate-model';

const DocumentTypeModalCreate = ({
  ctrl,
}: {
  ctrl: DocumentTypeControllerState & DocumentTypeControllerAction;
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Box padding={4}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography fontSize="24px">ສ້າງປະເພດເອກະສານໃໝ່</Typography>
          <CloseButton onClick={() => ctrl.onHandleModal(null)} />
        </Box>
        <Divider sx={{ backgroundColor: '#1A1A1A20', mt: 1.5, mb: 2.5 }} />
        <List>
          <Collapse unmountOnExit={true} orientation={'vertical'} in={ctrl?.message ? true : false}>
            <Alert severity={'error'}>{ctrl?.message ?? ''}</Alert>
          </Collapse>

          <Box marginTop={'50px'}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box flex={1}>
                  <Box sx={{ display: 'flex', gap: 2, mb: '20px' }}>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={ctrl.formCreate?.flow_type === FormFlowType.NORMAL}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            ctrl.onUpdateFormCreate({
                              ...ctrl.formCreate,
                              flow_type: event.target.value,
                            });
                          }}
                          value={FormFlowType.NORMAL}
                        />
                      }
                      label={'ແບບທົ່ວໄປ'}
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          checked={ctrl.formCreate?.flow_type === FormFlowType.INFORMED}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            ctrl.onUpdateFormCreate({
                              ...ctrl.formCreate,
                              flow_type: event.target.value,
                            });
                          }}
                          value={FormFlowType.INFORMED}
                        />
                      }
                      label={'ເພື່ອຮັບຊາບ'}
                    />
                  </Box>
                  <TextField
                    fullWidth
                    size="small"
                    type="text"
                    InputLabelProps={{ shrink: true }}
                    label="ຊື່ປະເພດ (EN)"
                    placeholder="please enter"
                    value={ctrl.formCreate?.name_en}
                    onChange={(e) =>
                      ctrl.onUpdateFormCreate({ ...ctrl.formCreate, name_en: e.target.value })
                    }
                  />
                  <Box marginTop={'30px'} />
                  <TextField
                    fullWidth
                    size="small"
                    type="text"
                    InputLabelProps={{ shrink: true }}
                    label="ຊື່ປະເພດ (LA)"
                    placeholder="please enter"
                    value={ctrl.formCreate?.name_la}
                    onChange={(e) =>
                      ctrl.onUpdateFormCreate({ ...ctrl.formCreate, name_la: e.target.value })
                    }
                  />
                  <Box marginTop={'30px'} />
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={5}
                    InputLabelProps={{ shrink: true }}
                    label="ເນື້ອໃນ"
                    placeholder="ປ້ອນຄໍາອະທິບາຍ"
                    value={ctrl.formCreate?.description}
                    onChange={(e) =>
                      ctrl.onUpdateFormCreate({ ...ctrl.formCreate, description: e.target.value })
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box flex={1}>
                  <Box sx={{ mb: '20px' }}>
                    <FormControl size="small" fullWidth>
                      <InputLabel shrink>ເລືອກໝວດໝູ່</InputLabel>
                      <Select
                        label="ເລືອກໝວດໝູ່"
                        value={ctrl?.formCreate?.document_type_category_id ?? ''}
                        displayEmpty
                        renderValue={() => {
                          var found = ctrl?.listDocTypeCate?.filter(
                            (e) => e.uuid === ctrl?.formCreate?.document_type_category_id
                          );
                          return (
                            <span style={{ color: '#5A5A5A' }}>
                              {found?.length > 0 ? found[0]?.name_la : 'ເລືອກໝວດໝູ່'}
                            </span>
                          );
                        }}
                      >
                        {ctrl?.listDocTypeCate?.map(
                          (item: DocumentTypeCategoryModel, index: number) => {
                            return (
                              <MenuItem
                                key={index}
                                onClick={() => {
                                  ctrl.onUpdateFormCreate({
                                    ...ctrl?.formCreate,
                                    document_type_category_id: item.uuid,
                                  });
                                }}
                                value={item.uuid}
                              >
                                <Typography marginLeft={2}>{item?.name_la}</Typography>
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                  <HexColorPicker
                    style={{ width: '100%' }}
                    color={ctrl.formCreate?.color_code ?? undefined}
                    onChange={(e) => ctrl.onUpdateFormCreate({ ...ctrl.formCreate, color_code: e })}
                  />
                  <Box flexDirection={'row'} display={'flex'} marginTop={'10px'}>
                    <Typography>ລະຫັດສີ:</Typography>
                    <Box marginLeft={'10px'}>
                      <Typography>{ctrl?.formCreate?.color_code ?? '#######'}</Typography>
                    </Box>
                  </Box>
                  <Box flexDirection={'row'} display={'flex'} marginTop={'10px'}>
                    <Typography>ຕົວຢ່າງ:</Typography>
                    <Box
                      width={'100px'}
                      height={'25px'}
                      bgcolor={ctrl?.formCreate?.color_code ?? '#FFFFFF'}
                      marginLeft={'10px'}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mt: '50px' }}>
            <Button
              onClick={() => ctrl.onHandleModal(null)}
              sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
              variant="outlined"
              size="small"
              fullWidth
            >
              ຍົກເລີກ
            </Button>
            <Button
              onClick={() => ctrl?.onSubmitForm(ctrl?.formCreate)}
              sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
              size="small"
              fullWidth
              variant="contained"
            >
              <Collapse unmountOnExit={true} orientation={'horizontal'} in={ctrl?.loading ?? false}>
                <CircularProgress size={'20px'} sx={{ color: 'white', marginRight: '10px' }} />
              </Collapse>
              ບັນທຶກ
            </Button>
          </Box>
        </List>
      </Box>
    </Box>
  );
};

export default DocumentTypeModalCreate;
